import apiClient from "@/services/ApiClient";

export default {
  name() {
    return "auth";
  },
  config() {
    return apiClient.get("/auth/config");
  },
  login(credentials) {
    return apiClient.post("/auth/login", credentials);
  },
};
